import * as React from 'react';
import OrgAssetsAdmin from './OrgAssetsAdmin';
import { OrgAssetsAdminStore } from './stores';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import { LoggingService } from '../../services/LoggingService';

export interface IOrgAssetsAdminProps {
  environment?: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
}

export class IAOrgAssetsAdmin extends React.Component<IOrgAssetsAdminProps> {

  private orgAssetsAdminStore: OrgAssetsAdminStore;

  constructor(props: IOrgAssetsAdminProps) {
    super(props);

    this.orgAssetsAdminStore = new OrgAssetsAdminStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.orgAssetsAdminStore.environment = props.environment;
    this.orgAssetsAdminStore.tenant = props.tenant;
    this.orgAssetsAdminStore.token = props.token;
    LoggingService.init(props.environment);
    
  }

  public componentWillReceiveProps(props: IOrgAssetsAdminProps) {
    if (props != this.props) {
      this.orgAssetsAdminStore.environment = props.environment;
      this.orgAssetsAdminStore.tenant = props.tenant;
      this.orgAssetsAdminStore.token = props.token;
    }
  }

  public render(): JSX.Element {
    return (
      <Provider orgAssetsAdminStore={this.orgAssetsAdminStore}>
        <OrgAssetsAdmin />
      </Provider>
    );
  }
}